import { IonIcon } from "@ionic/react";
import "./OfflineTabsHeader.css";
import {
  bagHandleOutline,
  bagHandleSharp,
  clipboardOutline,
  clipboardSharp,
  cogOutline,
  cogSharp,
} from "ionicons/icons";

export type OfflineTab = "work" | "equipment" | "cycleCount";

type Props = {
  active: OfflineTab;
  onChange: (tab: OfflineTab) => void;
};

export default function OfflineTabsHeader({ active, onChange }: Props) {
  return (
    <div className="tabs-header">
      <button
        className={`tab-btn ${active === "work" ? "active" : ""}`}
        onClick={() => onChange("work")}
      >
        <IonIcon ios={bagHandleOutline} md={bagHandleSharp} />
        <span>Work Orders</span>
      </button>

      <button
        className={`tab-btn ${active === "equipment" ? "active" : ""}`}
        onClick={() => onChange("equipment")}
      >
        <IonIcon ios={cogOutline} md={cogSharp} />
        <span>Equipment</span>
      </button>

      <button
        className={`tab-btn ${active === "cycleCount" ? "active" : ""}`}
        onClick={() => onChange("cycleCount")}
      >
        <IonIcon ios={clipboardOutline} md={clipboardSharp} />
        <span>Cycle Count</span>
      </button>
    </div>
  );
}
